
import { Options, Vue } from 'vue-class-component';
import { AdminClient, BaseAuthClient, CompanyManagerUserClient } from '@/services/Services';
import { LoginServices } from '@/services/LoginServices';
import InfoModal from '@/components/modals/infoModal.vue';
import store from '@/store';
import * as OM from "@/Model";

@Options({})
export default class Register extends Vue {

    languageCredential: OM.CompanyManagerRegisterData = new OM.CompanyManagerRegisterData();

    created() {
        var loggedUser = store.state.loggedUser;
        this.languageCredential.preferredCulture = loggedUser.preferredCulture;
    }

    register() {
        CompanyManagerUserClient.registerUser(this.languageCredential)
        .then(x => {
            LoginServices.LoginCallback(x.token, x.refreshToken);
        })
        .catch(y => {
            this.$opModal.show(InfoModal, {
                text:this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: y.Message,
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => {
                    this.$opModal.closeLast();
                }
            })
        })
    }

    get disabled() {
        return !this.languageCredential.username.trim() || !this.languageCredential.password.trim() || !this.languageCredential.companyName.trim();
    }

}
